import * as React from "react";
import { Select } from "@/components/bp/bp-ui";
import { LabKitClient } from "@app/api2/api";
import { useQuery } from "@tanstack/react-query";

interface ILabKitSelectorProps {
    labId: number;
    onChange?: (kitId: number) => void;
    name: string;
    readOnly: boolean;
    kitId: number;
    optionalText?: string;
}

export const LabKitSelector: React.FunctionComponent<ILabKitSelectorProps> = (props) => {
    const t = window.translation;
    const kitClient = new LabKitClient();
    const [kitId, setKitId] = React.useState(props.kitId)
    // const [kitList, setKitList] = React.useState([])

    // console.log('LabKitSelector props:', props);


    const query = useQuery({
        queryKey: ['LabKits', props.labId, props.optionalText],
        queryFn: async () => {
            const kits = (await kitClient.getAll(props.labId)).map((k) => ({ key: k.id, value: k.id, text: k.fullName }));
            if (props.optionalText != null) {
                return [{ key: null, value: null, text: props.optionalText }, ...kits];
            }
            return kits;
        },
        enabled: !!props.labId && props.labId > 0,
    });

    

    const onKitChange = (kitId: number) => {
        setKitId(kitId)
        if (props.onChange)
            props.onChange(kitId);
    }

    const selectedKit = query.data?.find(x => x.value == kitId);
    if (props.readOnly) {
        return (<span>{selectedKit != null ? selectedKit.text : ""}</span>)
    } else {
        return (
            <div>
                <Select name={props.name} value={kitId} options={query.data} onChange={(ev, d) => onKitChange(d.value != null ? parseInt(d.value.toString()) : null)} />
            </div>);
    }

}



